import { render, staticRenderFns } from "./InBlacklist.vue?vue&type=template&id=835bde68&scoped=true&"
import script from "./InBlacklist.vue?vue&type=script&lang=js&"
export * from "./InBlacklist.vue?vue&type=script&lang=js&"
import style0 from "./InBlacklist.vue?vue&type=style&index=0&id=835bde68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835bde68",
  null
  
)

export default component.exports